import { SET_IS_CURRENTLY_STREAMING } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function setIsCurrentlyStreaming(state: State, action: Action): State {
	if (action.type !== SET_IS_CURRENTLY_STREAMING) {
		return state
	}

	if (action.numberOfTokens) {
		if (state.tokensLeft - action.numberOfTokens > 0) {
			return {
				...state,
				tokensLeft: state.tokensLeft - action.numberOfTokens,
				isCurrentlyStreaming: action.isCurrentlyStreaming,
				currentMessageProcess: action.isCurrentlyStreaming
					? state.currentMessageProcess
					: null,
			}
		} else {
			return {
				...state,
				tokensLeft: 0,
				coinsLeft: 0,
				isCurrentlyStreaming: action.isCurrentlyStreaming,
				currentMessageProcess: action.isCurrentlyStreaming
					? state.currentMessageProcess
					: null,
			}
		}
	}

	return {
		...state,
		isCurrentlyStreaming: action.isCurrentlyStreaming,
		currentMessageProcess: action.isCurrentlyStreaming
			? state.currentMessageProcess
			: null,
	}
}
